import { Section, Eyebrow } from "./Section"

const PAINS = [
  "The show has no clear business purpose",
  "Guest selection feels random",
  "Episodes are published but not leveraged",
  "The host feels underprepared",
  "The podcast doesn't create enough authority",
  "The team doesn't have time to manage production",
]

export function Problem() {
  return (
    <Section>
      <div className="max-w-2xl">
        <Eyebrow>The problem</Eyebrow>
        <h2 className="display-2 mt-4">Most business podcasts become content chores</h2>
        <p className="mt-5 text-lg text-ink-body">
          Most experts don't need another content channel to manage. They need a
          better reason to build trust with the right people.
        </p>
        <p className="mt-4 text-ink-muted">
          A podcast can do that — but only when the strategy, guest ecosystem,
          interview flow, production, and follow-up assets are working together.
          Without that, even a well-produced show becomes another task on the
          calendar.
        </p>
      </div>

      <ul className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {PAINS.map((pain) => (
          <li
            key={pain}
            className="rounded-lg border border-hairline bg-surface p-5 text-ink-body"
          >
            {pain}
          </li>
        ))}
      </ul>
    </Section>
  )
}
